module.exports = __webpack_public_path__ + "img/VAT.3b3df986.svg";